"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCustomProperties = exports.PromotionServiceProperty = exports.PromotionAgreements = exports.PromotionFulfillmentStatus = void 0;
var PromotionFulfillmentStatus;
(function (PromotionFulfillmentStatus) {
    PromotionFulfillmentStatus["Completed"] = "completed";
    PromotionFulfillmentStatus["Partly"] = "partly";
    PromotionFulfillmentStatus["AllOpen"] = "allOpen";
})(PromotionFulfillmentStatus || (exports.PromotionFulfillmentStatus = PromotionFulfillmentStatus = {}));
var PromotionAgreements;
(function (PromotionAgreements) {
    PromotionAgreements["OravaPatient"] = "oravaPatient";
    PromotionAgreements["OnePermanentPrescription"] = "onePermanentPrescription";
    PromotionAgreements["OneOrderSincePaticipationDate"] = "oneOrderSincePaticipationDate";
})(PromotionAgreements || (exports.PromotionAgreements = PromotionAgreements = {}));
var PromotionServiceProperty;
(function (PromotionServiceProperty) {
    PromotionServiceProperty["ExportTimestamp"] = "promotions.export.timestamp";
})(PromotionServiceProperty || (exports.PromotionServiceProperty = PromotionServiceProperty = {}));
var PromotionCustomProperties;
(function (PromotionCustomProperties) {
    PromotionCustomProperties["mediaCode"] = "mediaCode";
    PromotionCustomProperties["voucherValue"] = "voucherValue";
    PromotionCustomProperties["validUntilForDashboardDisplay"] = "validUntilForDashboardDisplay";
})(PromotionCustomProperties || (exports.PromotionCustomProperties = PromotionCustomProperties = {}));
//# sourceMappingURL=promotions.js.map